import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MapPin, Calendar } from 'lucide-react';
import { Helmet } from 'react-helmet';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`/api/projects.json`);
      setProjects(response.data);
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen">
      <Helmet>
        <title>Construction Projects Portfolio Toronto & GTA | Commercial Fit-Out Case Studies | Oracle</title>
        <meta name="description" content="Explore Oracle Project Group's portfolio of completed  in Toronto & GTA. Interior fit-outs, office renovations, design-build successes. View our work." />
        <link rel="canonical" href="https://oracleprojectgroup.com/projects" />
        <meta property="og:title" content="Construction Projects Toronto & GTA | Oracle Project Group Portfolio" />
        <meta property="og:description" content="View our completed : interior fit-outs, office renovations, design-build in Toronto & GTA." />
        <meta property="og:url" content="https://oracleprojectgroup.com/projects" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Construction Projects Toronto & GTA | Oracle Project Group Portfolio" />
        <meta name="twitter:description" content="View our completed commercial construction projects: interior fit-outs, office renovations, design-build in Toronto & GTA." />
        <meta name="keywords" content="construction projects Toronto, commercial fit-out portfolio, office renovation examples, design-build case studies, GTA construction" />
      </Helmet>
      {/* Hero Section */}
      <header className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_build-marble/artifacts/2w882zt4_TJG_2_BloorstE_3WEB.jpg"
          alt="Projects - Oracle Project Group portfolio"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Our Projects</h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Discover our portfolio of exceptional construction projects across the GTA.
          </p>
        </div>
      </header>

      {/* Projects Grid */}
      <section className="py-20 bg-[#F6F6F7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37]"></div>
              <p className="mt-4 text-gray-600">Loading projects...</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project) => (
                <div
                  key={project.id}
                  className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute top-4 right-4">
                      <span className="px-3 py-1 bg-[#D4AF37] text-white text-xs font-semibold rounded-full">
                        {project.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-[#0F1115] mb-3">{project.title}</h3>
                    <p className="text-gray-600 mb-4">{project.description}</p>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <div className="flex items-center space-x-2">
                        <MapPin size={16} className="text-[#C6A45B]" />
                        <span>{project.location}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Calendar size={16} className="text-[#C6A45B]" />
                        <span>{project.year}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Projects;
